import { closeForm } from '@/store/module/scheduler/action/closeForm';
import { createEvent } from '@/store/module/scheduler/action/createEvent';
import { deleteEvent } from '@/store/module/scheduler/action/deleteEvent';
import { openForm } from '@/store/module/scheduler/action/openForm';
import { updateEvent } from '@/store/module/scheduler/action/updateEvent';

export const actions = {
	closeForm,
	createEvent,
	deleteEvent,
	openForm,
	updateEvent
};
